import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { NamedEntity } from '../../../types/entities/NamedEntity';
import { PagedData } from '../../../types/PagedData';
import { SchemaWithClient } from '../../../types/SchemaWithClient';
import { debounce } from 'lodash';
import { Popper } from '@mui/material';
import api from '../../../services/api';

type Props<T extends NamedEntity> = {
  active: boolean;
  onChange: (value: T[]) => void;
  schema: SchemaWithClient<T>;
  value?: T[];
  addingNewEntity?: boolean;
  hasTooltip: boolean;
  disabled: boolean;
  mui: boolean;
  column?: any;
  title?: string;
  allValue?: any;
  mainSchema?: any;
};

export const SetField = <T extends NamedEntity>({
  active,
  onChange,
  schema,
  value = [],
  hasTooltip,
  addingNewEntity,
  disabled,
  mui,
  column,
  title,
  allValue,
  mainSchema,
}: Props<T>): ReactElement | null => {
  const [options, setOptions] = useState<PagedData<T>>();
  const [addingEntity, setAddingEntity] = useState(false);

  const [inputValue, setInputValue] = React.useState('');

  const debouncedSetInputValue = debounce(setInputValue, 500);

  const handleChange = (event: any) => {
    debouncedSetInputValue(event.target.value);
  };

  const handleOpen = (event: any) => {
    console.log('OPEN');
  };

  const fetchOptions = useCallback(() => {
    const searchParams = new URLSearchParams({
      searchValue: inputValue,
    });

    return schema.client.readAll(1, searchParams).then(setOptions);
  }, [schema.client, inputValue]);

  useEffect(() => {
    if (active) fetchOptions();
  }, [active, fetchOptions]);

  const fetchSelectOptions = async (
    searchText: string,
    columnName?: string,
    row?: any
  ) => {
    setLoading(true);

    const searchParams = new URLSearchParams({
      searchValue: searchText,
    });

    if (column === 'strippers') {
      searchParams.append(
        'filters',
        JSON.stringify({
          activity_reservation: {
            0: { id: row?.id },
          },
        })
      );
    }

    if (mainSchema && mainSchema.name === 'Service Group') {
      if (column?.name === 'Services') {
        searchParams.append(
          'serviceProvider',
          JSON.stringify(allValue?.service_provider?.id)
        );
      }
    }

    if (column?.url) {
      api.get(`/${column?.url}`, searchParams).then((result: any) => {
        result.data.unshift({ id: 0, name: '', isButton: true });
        setSelectOptions(result.data);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  };

  const handleOnChange = (event: any, value: any) => {
    let isReturn = false;
    const newValue = value.filter((item: any) => {
      if (item?.isButton) {
        isReturn = true;
      }
      return !item?.isButton;
    });

    if (isReturn) {
      setCurrentEntity(undefined);
      setAddingEntity(true);
    } else {
      onChange(value);
    }
  };
  const CustomPopper = function (props: any) {
    return (
      <>
        <div>
          <Popper
            {...props}
            style={{ width: 'fit-content', maxWidth: '300px' }}
            placement="bottom-start"
            disableListWrap={true}
            sx={{
              '& .MuiPaper-root': {
                boxShadow: '0 4px 10px -1px rgb(17 20 24 / 20%)',
              },
            }}
          ></Popper>
        </div>
      </>
    );
  };
  const [loading, setLoading] = useState(false);
  const [selectOptions, setSelectOptions] = useState<[any]>([value]);
  const [currentEntity, setCurrentEntity] = React.useState<any>();

  return (
    <>

      {addingEntity && (
       /* <EntityDialog
          schema={schema}
          onClose={() => setAddingEntity(false)}
          isOpen={addingEntity}
          onSubmit={(addedItem) => {
            fetchOptions();
            onChange([...value, addedItem as T]);
          }}
          row={allValue}
          properties={allValue}
        />*/
        <></>
      )}
    </>
  );
};

SetField.tableAdapter = <T extends NamedEntity = NamedEntity>(
  schema: SchemaWithClient<T>
) => {
  const Field: FieldComponent<T[], T[]> = ({
    onChange,
    isActive: active,
    value,
    hasTooltip,
    addingNewEntity,
    mui,
    disabled,
    column,
    title,
    allValue,
    mainSchema,
  }) => (
    <SetField
      active={active}
      onChange={onChange}
      schema={schema}
      value={value}
      hasTooltip={hasTooltip ? true : false}
      addingNewEntity={addingNewEntity ? true : false}
      mui={mui ? true : false}
      disabled={disabled ? true : false}
      column={column ? column : {}}
      title={title}
      allValue={allValue}
      mainSchema={mainSchema}
    />
  );

  Field.includes = () => false;
  Field.comparator = () => 0;

  Field.FilterRenderer = (props) => {
    return (
      <>
        <Field {...props} isActive />
      </>
    );
  };

  return Field;
};
